import moment from 'moment';

export const customerExcelConfig = {
  fileName: 'Customers',
  sheetName: 'Customers',
  columns: [
    {
      header: 'Name',
      key: 'name',
    },
    {
      header: 'Email',
      key: 'email',
    },
    {
      header: 'Phone',
      key: 'phone',
    },
    {
      header: 'Created Date',
      key: 'createdAt',
      formatter: (row: any) =>
        row.createdAt
          ? moment(row.createdAt).format('DD-MM-YYYY')
          : 'N/A',
    },
    {
      header: 'Address',
      key: 'address',
    },
    {
      header: 'Status',
      key: 'status',
    },
  ],
};
